import UserNotFoundSection from './UserNotFoundSection';

export default UserNotFoundSection;
